// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"128":"b7a48a86","143":"fb665388","155":"edec9e94","352":"9a16cde6","493":"27948c66","927":"6451eab3"}[chunkId] + ".chunk.css";
};